import {Stack, TextField} from "@mui/material";
import type {MeasurementResolver, Resolver} from "../../../../../../sdo/Resolver.ts";
import {MEASURE_TYPES, unitsForType} from "../../../../../../sdo/Measurement.ts";
import {MatchModeRow, F, Sel, SummaryPill, SummaryPillRow, rowSx, fieldSx, set, setNum, type ResolverEditorProps} from "./ResolverUtils.tsx";

function MeasurementEditor({draft, editing, onChange}: ResolverEditorProps & { draft: MeasurementResolver }) {
    if (!editing) {
        return (
            <Stack direction="column" spacing={0.5} sx={{alignItems: "center", width: "100%"}}>
                <SummaryPillRow>
                    <SummaryPill label="Type" value={draft.measurementType}/>
                    <SummaryPill label="Unit" value={draft.unit}/>
                </SummaryPillRow>
                <SummaryPillRow>
                    <SummaryPill label="Value" value={draft.value}/>
                    <SummaryPill label="Precision" value={draft.precision}/>
                </SummaryPillRow>
            </Stack>
        );
    }

    const updNum = (key: string, raw: string) => setNum(draft, key, raw, onChange);
    const availableUnits = unitsForType(draft.measurementType);

    return (
        <Stack direction="column" spacing={1} alignItems="center">
            <MatchModeRow draft={draft} editing={editing} onChange={onChange}/>
            <Stack direction="row" sx={rowSx}>
                <Sel
                    value={draft.measurementType} label="Measurement Type"
                    onChange={(v) => {
                        const newUnits = unitsForType(v);
                        const newUnit = newUnits.length > 0 ? newUnits[0].key : "";
                        onChange({...draft, measurementType: v, unit: newUnit} as Resolver);
                    }}
                    minWidth="150px"
                    options={MEASURE_TYPES.map(t => ({value: t.key, label: t.display}))}
                />
                <Sel
                    value={draft.unit} label="Unit of Measure"
                    onChange={(v) => set(draft, "unit", v, onChange)}
                    minWidth="160px"
                    options={availableUnits.map(u => ({value: u.key, label: `${u.display} (${u.symbol})`}))}
                />
            </Stack>
            <Stack direction="row" sx={rowSx}>
                <F value={draft.value} placeholder="Value" onChange={(v) => updNum("value", v)} width="160px"/>
                <TextField
                    size="small" type="number" value={draft.precision} label="Precision"
                    onChange={(e) => updNum("precision", e.target.value)}
                    sx={{...fieldSx, width: "100px"}}
                    inputProps={{min: 0, max: 99}}
                />
            </Stack>
        </Stack>
    );
}

export default MeasurementEditor;
